<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75);
    z-index: 10;
  }

  .modal {
    position: relative;
    top: 12px;
    width: 290px;
    margin: auto;
    max-height: 90%;
    background: white;
    border-radius: 5px;
    z-index: 100;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
    overflow-x: hidden;
    overflow-y: auto;
  }

  h3 {
    padding: 1rem;
    margin: 0;
    border-bottom: 1px solid #ccc;
    font-family: 'Roboto Slab', sans-serif;
  }

  .content {
    padding: 1rem;
  }

  footer {
    padding: 1rem;
  }
  @media (min-width: 500px) {
    .modal {
      width: 450px;
    }
  }

  @media (min-width: 700px) {
    .modal {
      width: 600px;
    }
  }
</style>

<script>
  import { getContext } from 'svelte'
  import { fly, fade } from 'svelte/transition'
  import Button from './Button.svelte'
  import {
    getStatistics,
    updateStatistics,
    resetStatistics,
  } from './storage.js'

  export let title

  const closeModal = getContext('close')

  const statistics = getStatistics()

  function close() {
    closeModal()
  }
</script>

<div transition:fade class="modal-backdrop">
  <div transition:fly="{{ y: 300 }}" class="modal">
    <h3>{title}</h3>
    <div class="content">
        <div>Stats</div>
        <div>Games Played {statistics.gamesPlayed}</div>
        <div>Games Won {statistics.gamesWon}</div>
        <div>Games Lost {statistics.gamesLost}</div>
        <div>Games Tied {statistics.gamesTied ? statistics.gamesTied : 0}</div>
    </div>
    <footer>
      <slot name="footer">
        <Button on:click="{closeModal}">Close</Button>
      </slot>
    </footer>
  </div>
</div>
